import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faKey,
  faUsers,
  faSitemap,
  faBuilding,
  faRandom,
  faRobot,
  faCogs,
  faTasks,
  faShareAlt,
  faHistory,
  faCreditCard,
  faChartLine,
  faBriefcase,
  faUserCog,
  faReceipt,
  faCopyright,
  faBookOpen,
  faProjectDiagram,
  faArrowCircleDown,
  faFileImport,
} from "@fortawesome/free-solid-svg-icons";
import { history } from "./../history";

import { getDecryptedItem } from "../utility/encryptedStorage";
import { MODULE_NAME } from "../utility/ModuleConstants";

// var userId = "";
// userId = getDecryptedItem("id");
// const token = getDecryptedItem("token");

// const CONFIG = getUrl();
// const WORKBENCH_URL = CONFIG.URL.WORKBENCH.GET_WORKBENCH_URL;
// const BILLING_MANAGER_URL = CONFIG.URL.BILLING_MANAGER.DASHBOARD_URL;

const loginData = JSON.parse(getDecryptedItem("data"));
// if (loginData !== null) {
//
// } else {
//   history.push("/login");
// }
const navigationConfig = [
  {
    id: MODULE_NAME.HOME,
    title: "Home",
    type: "item",
    icon: <FontAwesomeIcon icon={faHome} />,
    permissions: ["admin", "editor"],
    navLink: "/",
  },

  {
    id: MODULE_NAME.WORKBENCH,
    groupTitle: "Workbench",
    type: "groupHeader",
    icon: <FontAwesomeIcon icon={faBriefcase} />,
  },
  {
    id: MODULE_NAME.INTELIEDOCS,
    title: "IntElieDocs",
    type: "item",
    icon: <FontAwesomeIcon icon={faRobot} className="menu-icon" />,
    permissions: ["admin", "editor"],
    navLink: "/workbench/Intelie-docs",
  },
  {
    id: MODULE_NAME.ORCHESTRATOR,
    title: "Orchestrator",
    type: "collapse",
    icon: <FontAwesomeIcon icon={faCogs} className="menu-icon" />,
    children: [
      {
        id: MODULE_NAME.SMART_EXTRACT_BUILDER,
        title: "Smart Extract Builder",
        type: "item",
        icon: <FontAwesomeIcon icon={faShareAlt} className="menu-icon" />,
        permissions: ["admin", "editor"],
        navLink: "/workbench/orchestrator/smart-extract-builder",
      },
      {
        id: MODULE_NAME.SMART_EXTRACT_MAPPER,
        title: "Smart Extract Mapper",
        type: "item",
        icon: <FontAwesomeIcon icon={faRandom} className="menu-icon" />,
        permissions: ["admin", "editor"],
        navLink: "/workbench/orchestrator/smart-extract-mapper",
      },
      {
        id: MODULE_NAME.SMART_CLASSES,
        title: "Smart Classes",
        type: "item",
        icon: <FontAwesomeIcon icon={faSitemap} className="menu-icon" />,
        permissions: ["admin", "editor"],
        navLink: "/workbench/orchestrator/smart-classes",
      },
      {
        id: MODULE_NAME.SMART_QUEUE,
        title: "Smart Queue",
        type: "item",
        icon: <FontAwesomeIcon icon={faTasks} className="menu-icon" />,
        permissions: ["admin", "editor"],
        navLink: "/workbench/orchestrator/smart-queue",
      },
    ],
  },

  {
    id: MODULE_NAME.ELIE_CONNECT,
    groupTitle: "ElieKonnect",
    type: "groupHeader",
    icon: <FontAwesomeIcon icon={faProjectDiagram} />,
  },
  {
    id: MODULE_NAME.IMPORT_CONNECTOR,
    title: "Import Connector",
    type: "item",
    icon: <FontAwesomeIcon icon={faFileImport} className="menu-icon" />,
    permissions: ["admin", "editor"],
    navLink: "/ElieKonnect/import-connector",
  },
  {
    id: MODULE_NAME.EXPORT_CONNECTOR,
    title: "Export Connector",
    type: "item",
    icon: <FontAwesomeIcon icon={faCogs} className="menu-icon" />,
    navLink: "/ElieKonnect/export-connector",
  },

  {
    id: MODULE_NAME.ACCESS,
    groupTitle: "Access Console",
    type: "groupHeader",
    icon: <FontAwesomeIcon icon={faUserCog} />,
  },
  {
    id: MODULE_NAME.UM,
    title: "User Manager",
    type: "item",
    icon: <FontAwesomeIcon icon={faUsers} className="menu-icon" />,
    permissions: ["admin", "editor"],
    navLink: "/access-console/um",
  },
  {
    id: MODULE_NAME.ORGANISATION,
    title: "Organisation Manager",
    type: "item",
    icon: <FontAwesomeIcon icon={faBuilding} className="menu-icon" />,
    permissions: ["admin", "editor"],
    navLink: "/access-console/organisation",
  },
  {
    id: MODULE_NAME.API_KEY,
    title: "API Key",
    type: "item",
    icon: <FontAwesomeIcon icon={faKey} className="menu-icon" />,
    permissions: ["admin", "editor"],
    navLink: "/access-console/api-key",
  },

  {
    id: MODULE_NAME.BILLING,
    groupTitle: "Billing Center",
    type: "groupHeader",
    icon: <FontAwesomeIcon icon={faReceipt} />,
  },
  {
    id: MODULE_NAME.DASHBOARD,
    title: "Dashboard",
    type: "item",
    icon: <FontAwesomeIcon icon={faChartLine} className="menu-icon" />,
    permissions: ["admin", "editor"],
    navLink: "/billing-center/dashboard",
  },
  {
    id: MODULE_NAME.HISTORY,
    title: "History",
    type: "item",
    icon: <FontAwesomeIcon icon={faHistory} className="menu-icon" />,
    permissions: ["admin", "editor"],
    navLink: "/billing-center/history",
  },
  {
    id: MODULE_NAME.SUBSCRIPTION_MANAGER,
    title: "Subscription Manager",
    type: "item",
    icon: <FontAwesomeIcon icon={faCreditCard} className="menu-icon" />,
    permissions: ["admin", "editor"],
    navLink: "/billing-center/subscription-manager",
    // parentOf: "/billing-center/subscription-manager/:id",
  },
  {
    id: "",
    groupTitle: "",
    type: "empty-header",
    icon: "",
  },
  {
    id: MODULE_NAME.BRANDING,
    title: "Branding",
    type: "item",
    icon: <FontAwesomeIcon icon={faCopyright} className="menu-icon" />,
    permissions: ["admin", "editor"],
    navLink: "/branding",
  },
  // {
  //   id: MODULE_NAME.COST_ESTIMATOR,
  //   title: "Cost Estimator",
  //   type: "item",
  //   icon: <FontAwesomeIcon icon={faBookOpen} className="menu-icon" />,
  //   permissions: ["admin", "editor"],
  //   navLink: "/cost-estimator",
  // },

  {
    id: MODULE_NAME.ORCHESTRATOR_SERVER,
    title: "Orchestrator Server",
    type: "item",
    icon: <FontAwesomeIcon icon={faCogs} className="menu-icon" />,
    navLink: "/orchestrator-server",
  },

  ,
  // {
  //   id: MODULE_NAME.DOCUMENTATION,
  //   title: "Documentation",
  //   type: "item",
  //   icon: <FontAwesomeIcon icon={faBookOpen} className="menu-icon" />,
  //   permissions: ["admin", "editor"],
  //   navLink: "/api-documentation",
  // }
  {
    id: MODULE_NAME.DOCUMENTATION,
    title: "Documentation",
    type: "collapse",
    icon: <FontAwesomeIcon icon={faBookOpen} className="menu-icon" />,
    children: [
      {
        id: MODULE_NAME.INTELIDOCS_MANUAL,
        title: "Intelidocs Manual",
        type: "item",
        icon: <FontAwesomeIcon icon={faRobot} className="menu-icon" />,
        permissions: ["admin", "editor"],
        navLink: "/api-documentation",
      },
      {
        id: MODULE_NAME.INTELIECONNECT_MANUAL,
        title: "ElieKonnect Manual",
        type: "item",
        icon: <FontAwesomeIcon icon={faProjectDiagram} className="menu-icon" />,
        permissions: ["admin", "editor"],
        navLink: "/connect-documentation",
      },
    ],
  },

  // {
  //   id: MODULE_NAME.USER_MANUAL,
  //   title: "User Manual",
  //   type: "item",
  //   icon: <FontAwesomeIcon icon={faBookOpen} className="menu-icon" />,
  //   permissions: ["admin", "editor"],
  //   navLink: "/user-manual",
  // },
];

const configSetupSubModules = [
  "Export Connectors",
  "Import Connectors",
  "Process Flow Setup",
  "askelie AI Setup",
  "Extraction Setup",
  "Insight Setup",
  "Model Setup",
  "KB Setup",
];

export { navigationConfig, configSetupSubModules };
